import type { PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import { useCuration } from '@hooks/useCuration';

import { TrackerType } from '@models/vital-sign';

import FormDrilldown from '@views/Records/VitalSigns/FormDrilldown';

export default function BodyDrilldownPage({ params }: PageProps) {
  const { stopCurating } = useCuration();
  useEffect(() => {
    return () => stopCurating();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RoleGuard roles={[RoleName.Curator, RoleName.Practitioner]}>
      <FormDrilldown {...params} type={TrackerType.Body} />
    </RoleGuard>
  );
}
